$(document).ready(function(){
		$(".slider--front").removeClass('height');
    $(".js-up").on("click", function () {
        var body = $("html, body");
        body.stop().animate({scrollTop: 0}, 1500, 'swing');
    });
    $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        if (scroll > 900) {
            $(".js-up").addClass("visible");
            $(".homeNav").addClass("homeNav--hidden");
        } else {
            $(".js-up").removeClass("visible");
             $(".homeNav").removeClass("homeNav--hidden");
        }
    });

    $('.button--question').on('click', function(){
         $([document.documentElement, document.body]).animate({
            scrollTop: $(".contact__box--form").offset().top - 150
        }, 2000);
        return false;
    });

    $('.main__sidebar').wrapInner('<div class="main__sidebar-innerwrap"></div>');
    // var sidebar = new StickySidebar('.main__sidebar', {
    //     containerSelector: '.main',
    //     innerWrapperSelector: '.main__sidebar-innerwrap',
    //     topSpacing: 100,
    //     bottomSpacing: 0
    // });
    $('.js-slider').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        dots: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 2000,
        dotsContainer: '.js-slider__dots',
        animateOut: 'fadeOut'
    });

		$(function(){
		  $('a[href^="#"]').on('click', function(event) {

		    event.preventDefault();

		    var sc = $(this).attr("href"),
		        dn = $(sc).offset().top - 200;


		    $('html, body').animate({scrollTop: dn}, 1000);

		  });
		});

    $('.js-clickableRow').on('click', function(){
        window.location = $(this).attr("data-href");
        console.log('a');
    });

    const tabs = $('.js-tabs');
    $('.tabs__nav-item').on('click', function(){
        var dataid = $(this).attr('data-id');
        $(this).addClass('active').siblings().removeClass('active');
        $('.tabs__container-text').removeClass('active').hide();
        $($('.tabs__container-text[data-id="'+dataid+'"]')).fadeIn('slow').addClass('active');

    });

    //offer carousel
    if ( $('.js-gallerySlider').length) {
        const $gallerySlider = $('.js-gallerySlider');
        const $gallerySlider1 = $gallerySlider.find($('.gallerySlider__main'));
        const $gallerySlider2 = $gallerySlider.find($('.gallerySlider__thumbs'));

        $gallerySlider1.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            mobileFirst: true,
            asNavFor: $gallerySlider2,
            fade: true,
            arrows: true,
            adaptiveHeight: true
            });
        $gallerySlider2.slick({
                slidesToScroll: 1,
                slidesToShow: 4,
                useTransform: false,
                prevArrow: ".gallerySlider__nav-left",
                nextArrow: ".gallerySlider__nav-right",
                asNavFor: $gallerySlider1,
                focusOnSelect: true,
                responsive: [
                {
                breakpoint: 500,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        var sliderAdaptiveHeight = function() {
            var heights = [];
            var items = $('.slick-active')
            items.each(function() {
                heights.push($(this).height());
            });
            $('.gallerySlider__main .slick-list').height(Math.max.apply(null, heights));
        }
        if ($('.gallerySlider__main').length) {
            sliderAdaptiveHeight();
        }

        $('.gallerySlider__main').on('afterChange', function(event, slick, currentSlide, nextSlide){
                sliderAdaptiveHeight();
        });
    }

    if ( $('.js-gallerySlider-realizations').length) {
        const $gallerySlider = $('.js-gallerySlider-realizations');
        const $gallerySlider1 = $gallerySlider.find($('.gallerySlider__main'));
        const $gallerySlider2 = $gallerySlider.find($('.gallerySlider__thumbs'));

        $gallerySlider1.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            mobileFirst: true,
            asNavFor: $gallerySlider2,
            fade: true,
            adaptiveHeight: true
            });

                var sliderAdaptiveHeight = function() {
                    var heights = [];
                    var items = $('.slick-active')
                    items.each(function() {
                        heights.push($(this).height());
                    });
                    $('.gallerySlider__main .slick-list').height(Math.max.apply(null, heights));
                }
                sliderAdaptiveHeight();

                $gallerySlider1.on('afterChange', function(event, slick, currentSlide, nextSlide){
                    sliderAdaptiveHeight();
                });

        $gallerySlider2.slick({
                slidesToScroll: 1,
                slidesToShow: 5,
                //rows: 0,
                useTransform: false,
                arrows: true,
                dots: true,
                asNavFor: $gallerySlider1,
                focusOnSelect: true,
                responsive: [
                {
                breakpoint: 500,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    //end offer carousel

    $('.js-invest__list-button').on('click', function(){
        $('.invest__list').toggleClass('invest__list--active');
    });
    if($(".js-sort-table").length) {
        $(".js-sort-table").tablesorter({
            theme: 'blue',
            headers: {
                0: { sorter: "digit"},

              }
        });
    }

    // $('.js-range-number').html($('.js-range-item').value);
    // $('.js-range-item').on("change mousemove", function() {
    //     $('.js-range-number').html($(this).val());
    // });
    $( ".js-range-item" ).slider({
        range: true,
        min: 0,
        max: 300,
        values: [ 10,100 ],
        slide: function( event, ui ) {
          $( ".js-range-number" ).text(  ui.values[ 0 ] +" - "+ ui.values[ 1 ] +" " );
        },
        stop: function(event, ui){
          $("[data-developer-filter='size_from']").val(ui.values[0]).trigger('change');
          $("[data-developer-filter='size_to']").val(ui.values[1]);
        }
      });
      $( ".js-range-number" ).text( $( ".js-range-item" ).slider( "values", 0 ) +
        " - " + $( ".js-range-item" ).slider( "values", 1 ) +" " );

    //var resizeEvt;
    //$('.js-image-map').maphilight();
    //$('.js-image-map').rwdImageMaps();

    // $(window).on('resize.usemaps', function(){
    //     clearTimeout(resizeEvt);
    //     resizeEvt = setTimeout(function(){
    //         $('.js-image-map').maphilight();
    //     }, 200);
    // });

    $('.image-map').on('mouseover','area', function(){
        var i, x = [], y = [];
            var c = $(this).attr('coords').split(',');
            var title = $(this).attr('data-tooltip-title');
            var content = $(this).attr('data-tooltip-content');
            var containerLeft = $('.js-image-map').offset().left;
            var containerWidth = $('.js-image-map').width();
            var tooltipWidth = $('.js-invest__tooltip').width();

            if(typeof title!=="undefined" && title!=""){
              for (i=0; i < c.length; i++){
              x.push( c[i++] );
              y.push( c[i] );
              }
              var top = y.sort(num)[0];
              var left = x.sort(num)[0];
              function num(a, b){ return (a-b); }
              //console.log('top: '+top+"left: "+left);

              $('.js-invest__tooltip').find(".tooltip__name").html(title);
              if(typeof content !== "undefined" && content!="")
                $('.js-invest__tooltip').find(".tooltip__text").html(content)
              $('.js-invest__tooltip').removeClass('tooltip--visible');
            //   console.log(containerLeft);
            //   console.log(left);
            //   console.log(tooltipWidth);


            if (left < tooltipWidth) {
                $('.js-invest__tooltip').css('top',"50%").css('transform','translateY(-50%)').css('right',"10px").css('left','auto').addClass('tooltip--visible');
                //console.log('a');
            } else {
                $('.js-invest__tooltip').css('top',"50%").css('transform','translateY(-50%)').css('left',"10px").css('right','auto').addClass('tooltip--visible');
               // console.log('b');
            }


              $('.invest__list').removeClass('invest__list--active');
            }
    }).on('mouseleave','area', function(){
        $('.js-invest__tooltip').removeClass('tooltip--visible');
    });

    $('.tooltip__close').on('click', function(){
        $(this).parent().removeClass('tooltip--visible');
    });


    // mail popup / single apartment
    $('.js-mailPopup__close, .mailPopup__overlay').on('click', function(){
        $("[data-developerform-message]").attr('class','').html('');
        $('.mailPopup').removeClass('mailPopup--visible');
    });
    $('.mailPopup__form .orange').on('click', function(){
        $(this).text(function(i, text){
            return text === "[Rozwiń]" ? "[Zwiń]" : "[Rozwiń]";
        });
        $(this).prev('span').toggleClass('big');
    });
    $('.js-share__item--mail').on('click', function(){
        $('.mailPopup').addClass('mailPopup--visible');
    });

    //remove link for calculator__buttons-item
    $('.calculator__buttons-item').click(function(){
        return false;
    });


    if ($(window).width() > 1100) {
        if ($(this).scrollTop() > 0) {
            $(".top").addClass("top--fixed");
        } else {
            $(".top").removeClass("top--fixed");
        }
    } else {
        $(".top").addClass("top--fixed");
    }



    $(window).on("scroll", function () {
       if ($(window).width() > 1100) {
            if ($(this).scrollTop() > 0) {
                $(".top").addClass("top--fixed");
            } else {
                $(".top").removeClass("top--fixed");
            }
        }
    });

    //rwd helper

    if ($(window).width() < 551){
        $('.calculator__buttons-item--calc').prependTo('form[data-developer-rentform="data-developer-rentform"]');
        //console.log('a');
    }

    // change colors of offer boxes

    $('.homeBoxes__item').each(function(){
        var color = $(this).data('color');
        $(this).find('.button').css('background',color);
        $(this).find('.homeBoxes__item-placeholder').css('color',color);
        $(this).find('.homeBoxes__item-line').css('background',color);
        $(this).find('.homeBoxes__item-triangle').css('border-top-color',color);
    });

  // lazyload
  const observer = lozad();
  observer.observe();

	$("[data-presentation-apartment]").bind('click',function(){
			var img = $(this).attr('data-href');
			$("#panorama").html("");

			pannellum.viewer('panorama', {
				"autoLoad": true,
				"type": "equirectangular",
				"panorama": img
			});

			$.magnificPopup.open({
			  items: {
			    src: '#presentationPopup'
			  },
			  type: 'inline',
				callbacks: {
					close: function() {
						setTimeout(function(){
							$('map area').each(function() {
								$(this).trigger('mouseout.maphilight');
							});
						},50);
					}
				}
			});
	});

	$("[data-presentation-apartment-projection]").bind('click',function(){
			var id = $(this).attr("data-presentation-apartment-projection");
			$("[data-presentation-apartment='"+id+"']").trigger('click');
	});

	$("[data-presentation-apartment-projection]").hover(function(){
		var color = $(this).closest("[data-developer-color]").attr('data-developer-color');
		var id = $(this).attr('data-presentation-apartment-projection');
		$("[data-presentation-apartment='"+id+"'").parent().css({'background-color':color});
		$("[data-presentation-apartment='"+id+"'").css({'color':'white'});
	},function(){
		var id = $(this).attr('data-presentation-apartment-projection');
		$("[data-presentation-apartment='"+id+"'").parent().css({'background-color':'white'});
		$("[data-presentation-apartment='"+id+"'").css({'color':'#545454'});
	});

	// $("#presentationPopup").bind('click',function(e){
	// 	if(e.target !== e.currentTarget) return;
	// 	$.magnificPopup.close();
	// });
});
